const COMPANY_SLUG_PATTERN = /^[a-z0-9-]{2,40}$/

const HOSTNAME_SLUG_MATCHERS: Array<[string, string]> = [
  ['sao-paulo', 'sao-paulo'],
  ['saopaulo', 'sao-paulo'],
  ['botafogo', 'botafogo'],
  ['fluminense', 'fluminense'],
  ['flamengo', 'flamengo'],
  ['palmeiras', 'palmeiras'],
  ['gremio', 'gremio'],
  ['santos', 'santos'],
  ['vasco', 'vasco'],
  ['barueri', 'barueri']
]

export const sanitizeCompanySlug = (
  value: string | null | undefined
): string | null => {
  if (!value) return null

  const normalized = `${value}`.trim().toLowerCase()
  return COMPANY_SLUG_PATTERN.test(normalized) ? normalized : null
}

export const getSafeCompanySlugFromQuery = (
  search: string
): string | null => {
  const params = new URLSearchParams(search)
  return sanitizeCompanySlug(params.get('cmp'))
}

export const getSafeCompanySlugFromHostname = (
  hostname: string
): string | null => {
  const normalizedHost = `${hostname || ''}`.trim().toLowerCase()
  if (!normalizedHost) return null
  if (
    normalizedHost === 'localhost' ||
    normalizedHost === '127.0.0.1' ||
    normalizedHost.endsWith('.local')
  ) {
    return null
  }

  const appMatch = normalizedHost.match(/^app-([a-z0-9-]+)\./)
  if (appMatch?.[1]) {
    return sanitizeCompanySlug(appMatch[1])
  }

  const contingencyMatch = normalizedHost.match(/^contingencia-([a-z0-9-]+)\./)
  if (contingencyMatch?.[1]) {
    return sanitizeCompanySlug(contingencyMatch[1])
  }

  const firstSegment = normalizedHost.split('.')[0]
  const sanitizedFirstSegment = sanitizeCompanySlug(firstSegment)

  for (const [matcher, slug] of HOSTNAME_SLUG_MATCHERS) {
    if (normalizedHost.includes(matcher)) {
      return slug
    }
  }

  return sanitizedFirstSegment
}
